import { createSelector } from '@reduxjs/toolkit';
import { AppState } from 'store/store';
import { useSelector } from 'react-redux';
import { useExplore } from 'features/explore/model/hooks/use-explore';
import { usePropEventRefresher } from '@zdrbm/zdr-react';

const exploresSelector = (state: AppState) => state.explore;

export const filtersSelector = createSelector(exploresSelector, (explore) => explore || {});

export const useExploreConfiguration = () => {
    return useSelector(filtersSelector);
};

export const useDashboardExploreConfiguration = () => {
    const exploreModel = useExplore();

    const [sessionParams] = usePropEventRefresher(exploreModel.configuration);

    return sessionParams!;
};
